// src/Redux/Dashboard/External/USER_PROFILE/UpdateTenantReducer.js

import {
  PATCH_USER_TENANT_REQUEST,
  PATCH_USER_TENANT_SUCCESS,
  PATCH_USER_TENANT_FAILURE,
  PATCH_USER_TENANT_RESET,
} from '../../../Constants/actionTypes';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const updateTenantReducer = (state = initialState, action) => {
  switch (action.type) {
    case PATCH_USER_TENANT_REQUEST:
      return { ...state, loading: true, error: null };
    case PATCH_USER_TENANT_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case PATCH_USER_TENANT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case PATCH_USER_TENANT_RESET:
      return initialState;
    default:
      return state;
  }
};

export default updateTenantReducer;
